import * as React from 'react'

import { Box, ProgressBar, Table } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import TextInput from 'modules/core/components/Inputs/Text'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type Goal from 'modules/goals/store/models/Goal'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

interface ProgressGoalProps {
  form: Form
}

function ProgressGoal({ form }: ProgressGoalProps) {
  const total = form.get('metadata.goal_value_in_cents').value
  const currentValue = form.get('metadata.current_value_in_cents').value
  const percentage = total > 0 ? Math.round((currentValue / total) * 100) : 0
  return <ProgressBar percentage={percentage} total={total} amount={currentValue} />
}

class NumericGoalForm extends Form {
  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(values: {}) {
    super(values, {
      id: 'string',
      owner_id: 'string',
      goal_config_id: 'string',
      progress_status: 'string',
      metadata: {
        id: 'string',
        goal_value_in_cents: 'cents',
        current_value_in_cents: 'cents',
        goal_progress: 'number',
      },
    })
  }
}

interface Props {
  goal: Goal
  goalConfig: GoalConfig
  options: Record<string, any>
}

const Numeric = ({ goal, goalConfig, options }: Props) => {
  const form = React.useRef(new NumericGoalForm(goal.toJS())).current

  const { performAction: updateGoal } = useAsyncAction(() => form.save(goal))

  const canEditGoalValue = goalConfig.isActive && goal.policy.can('editGoalGoalValue')

  const canEditCurrentValue = goalConfig.isActive && goal.policy.can('editGoalCurrentValue')

  const canEditProgressStatus = goalConfig.isActive && goal.policy.can('editGoalProgressStatus')

  return (
    <>
      <Table.Cell colSpan={2}>
        <TextInput
          label={i18n.t('surveys.goals.show.table.goal_value_label')}
          hideLabel
          type="text"
          onBlur={updateGoal}
          field={form.get('metadata.goal_value_in_cents')}
          readonly={!canEditGoalValue}
        />
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <TextInput
          label={i18n.t('surveys.goals.show.table.goal_progress_label')}
          hideLabel
          type="text"
          onBlur={updateGoal}
          field={form.get('metadata.current_value_in_cents')}
          readonly={!canEditCurrentValue}
        />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Box>
          <Select
            options={options}
            onBlur={updateGoal}
            field={form.get('progress_status')}
            readonly={!canEditProgressStatus}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <ProgressGoal form={form} />
      </Table.Cell>
    </>
  )
}

export default observer(Numeric)
